import React, { useEffect, useState } from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import {
  StyledContentContainer,
  StyledBackground,
  StyledGlascLogo,
  transitionOutDuration,
  mobileTransitionOutDuration,
} from "./ContentContainer.styled";
import { Menu } from "../../../data/types/Menu";
import { Products } from "../Products/Products";
import { Story } from "../Story/Story";
import { Founder } from "../Founder/Founder";
import { InfoText } from "../../../data/types/InfoText";

export interface ContentContainerProps {
  activeId: Menu;
  handleLogoClick: () => void;
}

export const ContentContainer: React.FC<ContentContainerProps> = ({
  activeId,
  handleLogoClick,
}) => {
  const [currentActiveId, setCurrentActiveId] = useState<Menu>("");
  const [products, setProducts] = useState<Array<InfoText>>([]);
  const [story, setStory] = useState<InfoText>();
  const [founder, setFounder] = useState<InfoText>();
  const { t } = useTranslation();
  const { language } = useI18next();

  useEffect(() => {
    const key = language === "en-us" ? "" : "home_";
    const products: Array<InfoText> = [...Array(2)].map((u, index) => ({
      title: t(`${key}product.${index}.title`),
      subtitle: t(`${key}product.${index}.subtitle`),
      description: t(`${key}product.${index}.description`),
    }));

    const story: InfoText = {
      title: t(`${key}menu.story`),
      descriptions: [...Array(3)].map((u, index) =>
        t(`${key}story.description.${index}`),
      ),
    };
    const founder: InfoText = {
      title: t(`${key}menu.founder`),
      descriptions: [...Array(2)].map((u, index) =>
        t(`${key}founder.description.${index}`),
      ),
    };

    setProducts(products.reverse());
    setStory(story);
    setFounder(founder);
  }, [language, t]);

  useEffect(() => {
    const delay =
      window.innerWidth < 1024
        ? mobileTransitionOutDuration
        : transitionOutDuration;
    setTimeout(() => {
      setCurrentActiveId(activeId);
    }, delay * 1000);
  }, [activeId]);

  return (
    <>
      <StyledBackground $activeId={activeId} />
      <StyledContentContainer
        $transitionOut={currentActiveId !== activeId}
        $alignCenter={
          currentActiveId === "story" || currentActiveId === "founder"
        }
      >
        {currentActiveId === "products" && <Products list={products} />}
        {currentActiveId === "story" && <Story {...story} />}
        {currentActiveId === "founder" && <Founder {...founder} />}
      </StyledContentContainer>
      <StyledGlascLogo $activeId={activeId} onClick={handleLogoClick} />
    </>
  );
};
